import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { useIsCurrentUserDeviationAuthor } from '../../utils/hooks/useIsCurrentUserDeviationAuthor';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import SubscribeButton from '../../Button/SubscribeButton';
import SubscribersOnly from '../../ActionBar/_partials/SubscribersOnly';
import Stats from '../../Stats';
import Benefit from '../../DeviationViews/TierProductCardDumb/Benefit';
import JournalTags from '../../DeviationViews/Details/_partials/JournalTags';
import Sidebar from '../../Sidebar';
import { getTierDescription } from '../../DeviationViews/_helpers';
import { isExtendedDeviationFullyLoaded } from '../redux/helpers';
import PanelPopup from '../_partials/PanelPopup';
import Comments from '../_partials/Comments';
import { useScrollToDeviationComments } from '../_partials/Comments/useScrollToDeviationComments';
import TierUpsell from '../_partials/TierUpsell';
import s from './MobileTierPage.scss';
const MobileTierPage = ({ deviation })=>{
    var _discord;
    const { t } = useTranslation();
    const isOwner = useIsCurrentUserDeviationAuthor(deviation);
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const scrollToDeviationComments = useScrollToDeviationComments();
    const { extended: { tags } = {}, tier: { benefits = [], discord } = {} } = deviation;
    const hasDiscord = (_discord = discord) === null || _discord === void 0 ? void 0 : _discord.connected;
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(ArtStage, {
        className: s['stage-content'],
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(ActionBar, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(PanelPopup, {
        deviation: deviation,
        actionBarType: "primary",
        className: s['large-popover-uplifted']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['details']
    }, !isOwner && /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            referral_info: ReferralType.TIER_UNIQUE
        }
    }, /*#__PURE__*/ React.createElement(SubscribeButton, {
        className: s['subscribe-button'],
        tier: deviation,
        withPrice: true
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['subscribers-and-stats']
    }, /*#__PURE__*/ React.createElement(SubscribersOnly, {
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(Stats, {
        deviation: deviation,
        withSubscriberCount: true,
        withViewCount: false,
        withBadges: false,
        onCommentClick: scrollToDeviationComments
    })), isExtendedLoaded ? /*#__PURE__*/ React.createElement(React.Fragment, null, tags && /*#__PURE__*/ React.createElement(JournalTags, {
        tags: tags
    }), /*#__PURE__*/ React.createElement("p", {
        className: s['description']
    }, getTierDescription(deviation)), /*#__PURE__*/ React.createElement("ul", {
        className: s['benefits']
    }, hasDiscord && /*#__PURE__*/ React.createElement(Benefit, {
        benefit: t('deviationview.tierCard.benefits.discord'),
        isDiscord: true,
        className: s['benefit']
    }), benefits.map((benefit)=>/*#__PURE__*/ React.createElement(Benefit, {
            key: benefit,
            benefit: benefit,
            className: s['benefit']
        }))), /*#__PURE__*/ React.createElement(Comments, {
        deviation: deviation,
        className: s['comments']
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['sidebar']
    }, /*#__PURE__*/ React.createElement(Sidebar, {
        deviation: deviation
    }))) : /*#__PURE__*/ React.createElement(LoadingIndicator, {
        className: s['lloader'],
        view: "llama"
    })), /*#__PURE__*/ React.createElement(TierUpsell, {
        className: s['upsell'],
        deviation: deviation
    }));
};
MobileTierPage.displayName = 'MobileTierPage';
export default MobileTierPage;
